function doneResizing() {

    $('article.article-item header').matchHeight({
        byRow: false,
    });

    $('article.article-item footer').matchHeight({
        byRow: false,
    });

    $('article.article-item div.body').matchHeight({
        byRow: false,
    });

    filterSlides();
}

function doneResizingWithoutInit() {
    adjustIframes();
}

function adjustIframes() {

	setTimeout(function () {
		$('.responsive-iframe').each(function(key, value) {
			let width = $(value).closest('.iframe-responsive-container').width();

			console.log(width);
			$(value).width(width);
			$(value).height(width * 0.65);
		});

		setLazyIframes();
	}, 300);

}

function setLazyIframes() {
	setTimeout(function () {
		$('body').find('.lazy-iframe').each(function (index, value) {
			let iframe = $(value);
			iframe.attr('src', iframe.data('src'));
			console.log("Setting iframes");
		});
	}, 300);
}

function filterSlides() {
    if ($(window).width() < 992) {
        $('.filtered-mobile').closest('.slick-slide').hide();
    } else {
        $('.filtered-mobile').closest('.slick-slide').show();
    }
}


$(window).scroll(function() {
    if (!$(window).scrollTop()) {
        $('nav.navbar').removeClass('scrolled');
    } else {
        $('nav.navbar').addClass('scrolled');
    }
});



$(document).ready(function() {

    setTimeout(function() {
        filterSlides();
    }, 1000);

    const csrf = $('meta[name="csrf-token"]').attr('content');
    const csrfObj = {
        'X-CSRF-TOKEN': csrf,
    };

    // pridava a odobera class slick v historii  - ovladam tym scrollovanie bannera//
    var alterClass = function() {
        var ww = document.body.clientWidth;
        if (ww < 992) {
            $('.slick-switch').removeClass('slick');
        } else if (ww >= 991) {
            $('.slick-switch').addClass('slick');
        }
    };
    $(window).resize(function() {
        alterClass();
        console.log('resize');
    });
    //Fire it when the page first loads:
    alterClass();

	adjustIframes();

    setLazyIframes();

    $('table.slider tr td').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        arrows: false,
        responsive: [{
            breakpoint: 992,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }, ]
    });

    $('.slick').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        arrows: false,
        responsive: [{
            breakpoint: 992,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }, ]
    }).on('init', function () {
        filterSlides();
    });

    $('.slick-positioned').slick({
        slidesToShow: 1.5,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        arrows: false,
        responsive: [{
            breakpoint: 992,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }, ]
    }).on('init', function () {
        filterSlides();
    });

    // $(window).resize(function() {
    //     filterSlides();
    // });

    $('.slick-reverse').slick({
        rtl: true,
        slidesToShow: 1.5,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        arrows: false,
        responsive: [{
            breakpoint: 992,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }, ]
    }).on('init', function () {
        filterSlides();
    });

    var resizeId;
    var resizeIdTwo;
    $(window).resize(function() {
        clearTimeout(resizeId);
        resizeId = setTimeout(doneResizing, 500);

        clearTimeout(resizeIdTwo);
        resizeIdTwo = setTimeout(doneResizingWithoutInit, 500);
    });

    doneResizing();

    $('.download-file-modal').click(function (e) {
        e.preventDefault();

        $('#downloadForm').data('id', $(this).data('id'));
    });

    $('#downloadButton').click(function (e) {
        e.preventDefault();
        let form = $('#downloadForm');
        let newAction = form.attr('action') + "/" + form.data('id');

        $.ajax({
            url: newAction,
            method: "GET",
            headers: csrfObj,
            data: form.serialize(),
            success: function (data) {
                if (data.result) {
                    $('#basicExampleModal').modal('hide');
                    form.attr('action', newAction);
                    form.submit();
                } else {
                    $('.error-alert').show();
                    $('.error-message').text(data.message);
                }
            }
        })
    });

    $('.navbar-collapse').on('click', '.nav-link.smooth-scroll', function (e) {
        $('.navbar-collapse').removeClass('show');
    });

    $('#header-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 10000,
        speed: 1000,
        fade: true,
        cssEase: 'linear',
        pauseOnHover: false,
    });

    $('.hover-black-white').mouseover(function (e) {
        let blackImg = $(this).data('blackimage');

        $(this).find('img').attr('src', blackImg);

    });

    $('.hover-black-white').mouseleave(function (e) {
        let whiteimage = $(this).data('whiteimage');

        $(this).find('img').attr('src', whiteimage);

    });
});
